import React, { useEffect, useState } from "react";

import HttpManager from "../../../../services/HttpManager";
import useEsTelefono from "../../../../utils/esTelefono";
import S from "./strings";
import { EstadoPill, Paginas, dinero, errorText, horaBonita, useOpciones, usePlantel } from "./comun";
import WorkshopForm from "./workshopForm";
import WorkshopDetail from "./workshopDetail";
import { fechaHoraAmPm } from "../../../../utils/fechaHoraAmPm";
import { WorkshopRowMultiDTO } from "../../../../services/v2/workshops.service";

type Chip = "" | "programado" | "realizado" | "anulado" | "historico";
const CHIPS: Chip[] = ["programado", "realizado", "anulado", "historico", ""];

/** Académico › Talleres (sección workshops, FASE 4): lista, alta/edición y detalle con inscritas e invitación. */
const WorkshopsController: React.FC = () => {
	const http = HttpManager.getInstance();
	const movil = useEsTelefono();
	const { campusId, campusName } = usePlantel();
	const opciones = useOpciones(campusId);
	const [chip, setChip] = useState<Chip>("programado");
	const [q, setQ] = useState<string>("");
	const [buscar, setBuscar] = useState<string>("");
	const [page, setPage] = useState<number>(1);
	const [data, setData] = useState<{ rows: WorkshopRowMultiDTO[]; total: number; lastPage: number } | null>(null);
	const [abierto, setAbierto] = useState<number | null>(null);
	const [nuevo, setNuevo] = useState<boolean>(false);
	const [aviso, setAviso] = useState<{ text: string; ok: boolean } | null>(null);
	const [tick, setTick] = useState<number>(0);

	useEffect(() => { const h = setTimeout(() => { setBuscar(q.trim()); setPage(1); }, 350); return () => clearTimeout(h); }, [q]);

	useEffect(() => {
		if (campusId === null || abierto !== null) return;
		let vigente = true;
		setData(null);
		http.workshopsService.list(campusId, { status: chip, q: buscar, page, perPage: 50 })
			.then(r => vigente && setData({ rows: r.data.rows || [], total: r.data.total || 0, lastPage: r.data.lastPage || 1 }))
			.catch(e => { if (vigente) { setData({ rows: [], total: 0, lastPage: 1 }); setAviso({ text: errorText(e), ok: false }); } });
		return () => { vigente = false; };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [campusId, chip, buscar, page, tick, abierto]);

	if (campusId === null) return <React.Fragment />;
	const notify = (text: string, ok = true) => setAviso({ text, ok });

	return (
		<div className={"wau" + (movil ? " movil" : "")}>
			<div className="wau-cab">
				<div>{campusName ? <span className="wau-ceja">{campusName}</span> : ""}<h2>{S.title}</h2></div>
				{abierto === null ? <button type="button" className="wau-btn p" onClick={() => setNuevo(true)}>{S.nuevo}</button> : null}
			</div>
			{aviso ? <div className={"wau-aviso " + (aviso.ok ? "ok" : "mal")} role="status"><span>{aviso.text}</span><button type="button" aria-label={S.cerrar} onClick={() => setAviso(null)}>×</button></div> : ""}
			{abierto !== null ? <WorkshopDetail campusId={campusId} id={abierto} opciones={opciones} onBack={() => setAbierto(null)} notify={notify} /> : (
				<>
					<div className="wau-chips" role="group">
						{CHIPS.map(c => <button key={c || "todos"} type="button" className="wau-chip" aria-pressed={chip === c} onClick={() => { setChip(c); setPage(1); }}>{c ? S.estados[c] : S.todos}</button>)}
						<input type="search" className="wau-entrada" style={{ width: 260, marginLeft: movil ? 0 : "auto" }} placeholder={S.buscar} value={q} onChange={e => setQ(e.target.value)} />
					</div>
					{data === null ? <div className="wau-caja wau-sec">{S.cargando}</div> : (
						<div className="wau-caja wau-tabla">
							<table>
								<thead><tr><th>{S.col.fecha}</th><th>{S.col.taller}</th><th>{S.col.lugar}</th><th className="der">{S.col.cupo}</th><th className="der">{S.col.pagadas}</th><th className="der">{S.col.precio}</th><th>{S.col.estado}</th></tr></thead>
								<tbody>
									{data.rows.length === 0 ? <tr><td colSpan={7} className="wau-sec" style={{ textAlign: "center", padding: 20 }}>{S.vacio}</td></tr> : data.rows.map(w => (
										<tr key={w.id} className="clic" onClick={() => setAbierto(w.id)}>
											<td className="wau-num" style={{ whiteSpace: "nowrap" }}>{fechaHoraAmPm(w.date)}<div className="wau-sec" style={{ fontSize: 12.5 }}>{w.time && w.time !== "00:00" ? horaBonita(w.time) : ""}</div>
												{(w.sessionsCount || 0) > 1 ? <div className="wau-sec" style={{ fontSize: 12.5 }}>{S.nSesiones(w.sessionsCount as number)}</div> : null}</td>
											<td><b>{w.name}</b><div className="wau-sec" style={{ fontSize: 12.5 }}>{w.courseName || w.area || ""}</div></td>
											<td style={{ fontSize: 13.5 }}>{[w.classroomName, w.mentorName].filter(Boolean).join(", ") || "—"}</td>
											<td className={"der wau-num" + (w.spotsLeft === 0 ? " wau-oro" : "")}>{w.attendees.total}{w.capacity ? " / " + w.capacity : ""}</td>
											<td className="der wau-num">{w.attendees.paid}</td>
											<td className="der wau-num">{dinero(w.currency, w.price)}</td>
											<td><EstadoPill status={w.status} label={w.statusLabel} /></td>
										</tr>
									))}
								</tbody>
							</table>
							<Paginas page={page} last={data.lastPage} total={data.total} onPage={setPage} />
						</div>
					)}
				</>
			)}
			{nuevo ? <WorkshopForm campusId={campusId} opciones={opciones} taller={null} onClose={() => setNuevo(false)}
				onSaved={(t, texto) => { setNuevo(false); notify(texto); setTick(x => x + 1); setAbierto(t.id); }} /> : null}
		</div>
	);
};

export default WorkshopsController;
